import { AxiosError } from "axios";

import { TemplateVariableGroup } from "@/constants/message-template.constants";
import { apiT2B } from "@/lib/axios";

const baseUrl = "/api/v1/CustomerTemplate";

type RawTag = {
  key?: string;
  label?: string;
  value?: string;
  source?: string;
  type?: string;
};

type RawGroup = {
  key?: string;
  label?: string;
  tags?: RawTag[];
};

export async function getCustomerTemplateTags(type?: string): Promise<TemplateVariableGroup[]> {
  try {
    const response = await apiT2B.get(`${baseUrl}/tags`, {
      params: type ? { type } : undefined,
    });

    const payload = (response.data?.data ?? response.data) as { groups?: RawGroup[] };
    const groups = payload?.groups ?? [];

    return groups
      .map((group) => ({
        title: group.label || group.key || "",
        variables: (group.tags ?? [])
          .map((tag) => tag.value || (tag.key ? `#${tag.key}#` : ""))
          .filter(Boolean),
      }))
      .filter((group) => group.variables.length > 0);
  } catch (error) {
    if (error instanceof AxiosError) {
      throw new Error(error.response?.data?.message || "Falha ao carregar as variáveis");
    }

    throw error instanceof Error ? error : new Error("Falha ao carregar as variáveis");
  }
}
